import Home from "./home"
import Profile from "./profile"
import AdminParameters from "./admin-parameters"
import AdmniVisitors from "./admin-visitors"
import Create from "./create"
import Approve from "./approve"
import MyMeeting from "./my-meeting"
import MeetingList from "./meeting-list"
import AdminRoom from "./admin-rooms"
import Edit from "./edit"
import Host from "./host"
import Statistic from "./statistic"

export {
    Home,
    Profile,
    AdminParameters,
    AdmniVisitors,
    AdminRoom,
    Create,
    Approve,
    MeetingList,
    MyMeeting,
    Edit,
    Statistic,
    Host,
}
